export default __webpack_public_path__ + "static/media/whatsapp.4a8733ff.svg";